<template>
  <div class="codelos-top-bar">
    <div class="codelos-left-top-menu">
      <ul
        v-if="!isPreviewSection"
        class="codelos-left-menu-list font-aktiv-grotesk"
      >
        <li
          class="codelos-left-menu-list-item"
          @click="goTo($event, 'data', getGotoDatabase)"
          :class="{ active: activeSection == 'data' }"
        >
          <img
            src="../assets/img/daten-icon-gray.svg"
            v-if="activeSection == 'data'"
          />
          <img src="../assets/img/daten-icon-light.svg" v-else />
          <span class="codelos-left-menu-list-text">DATEN</span>
        </li>
        <li
          @click="goTo($event, 'flows', 'process-list')"
          class="codelos-left-menu-list-item"
          :class="{ active: activeSection == 'flows' }"
        >
          <img
            v-if="activeSection == 'flows'"
            src="../assets/img/workflow-icon-new-gray.svg"
          />
          <img v-else src="../assets/img/workflow-icon-new-light.svg" />
          <span class="codelos-left-menu-list-text">WORKFLOWS</span>
        </li>
      </ul>
    </div>
    <div class="codelos-left-right-menu">
      <ul class="codelos-left-right-list font-aktiv-grotesk">
        <li class="codelos-left-right-list-item">
          <b-dropdown
            @show="toggleSignOutDropdown(true)"
            @hide="toggleSignOutDropdown(false)"
            class="codelos-signout-dropdown"
            right
            offset="10"
            :text="userName?.toUpperCase()"
          >
            <b-dropdown-text class="signout-username">
              {{ userName?.toUpperCase() }}
            </b-dropdown-text>
            <b-dropdown-text class="signout-email">
              {{ userEmail }}
            </b-dropdown-text>
            <b-dropdown-text
              class="signout-text signout-btn"
              v-if="user"
              @click="onSignOut"
              >Abmelden</b-dropdown-text
            >
            <b-dropdown-text class="signout-text">
              <div class="agb-container">
                <span
                  ><a href="https://codelos.notion.site/agb" target="_blank"
                    >AGB</a
                  ></span
                >
                <div class="vertical-line"></div>
                <span
                  ><a
                    href="https://codelos.notion.site/datenschutz"
                    target="_blank"
                    >Datenschutz</a
                  ></span
                >
              </div></b-dropdown-text
            >
          </b-dropdown>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import { mapGetters } from 'vuex';
import store from '../store/store';
import { resetVuex } from '@/utils/helpers.js';

export default {
  name: 'NavbarTop',
  data() {
    return {
      isSignOutDropdownVisible: false,
    };
  },
  props: {
    customUserNavItems: Array,
    activeDatabase: Object,
  },
  methods: {
    async goTo(event, section, database) {
      const isCtrlOrCmd = event.ctrlKey || event.metaKey;

      if (isCtrlOrCmd) {
        const query = new URLSearchParams({
          section,
          database,
        }).toString();

        window.open(`/#/?${query}`, '_blank');
      } else {
        await this.$router.push({
          path: '/',
          query: { section, database },
        });
      }
    },
    toggleSignOutDropdown(value) {
      if (value != this.isSignOutDropdownVisible)
        this.isSignOutDropdownVisible = value;
    },
    async onSignOut() {
      try {
        resetVuex();
        localStorage.clear();
        await Auth.signOut();
        this.$router.push({ path: '/auth' });
      } catch (error) {
        console.error('Error signing out:', error);
      }
    },
  },
  computed: {
    ...mapGetters({ userName: 'getUserName', userEmail: 'getUserEmail' }),
    user() {
      return store.state.user;
    },
    activeSection() {
      return this.$route.query.section;
    },
    isPreviewSection() {
      return this.$route.query.section === 'preview';
    },
    userSettings() {
      return store.state.userSettings;
    },
    getGotoDatabase() {
      return this.userSettings?.selectedDatabase
        ? this.userSettings?.selectedDatabase
        : this.customUserNavItems.length
        ? this.customUserNavItems[0].name
        : 'noDatabases';
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
@import 'https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One';

.codelos-top-bar * {
  box-sizing: border-box;
}

.codelos-signout-dropdown ul li:last-child {
  border-top: none;
  display: inline-block;
  width: 100%;
  padding-top: 17px;
}

.codelos-signout-dropdown ul .signout-username {
  font-family: 'AktivGroteskMedium';
  line-height: normal;
  user-select: none;
  padding-bottom: 12px;
}

.codelos-signout-dropdown ::v-deep ul {
  padding: 15px 18px 10px;
  box-shadow: 0 0 8px rgb(82 78 78 / 20%);
  border-radius: 10px;
  border-color: #cdcdcd;
}

.codelos-signout-dropdown .dropdown-menu .signout-username p {
  font-size: 14px;
  color: #58647d;
  font-weight: 600;
  padding: 0;
  user-select: none;
  letter-spacing: 0.5px;
}

.codelos-left-right-menu .codelos-left-right-list .signout-text button {
  font-size: 12px;
}

.codelos-signout-dropdown .dropdown-menu .signout-email p {
  padding: 0;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #c5c5c5;
  user-select: none;
}

.codelos-signout-dropdown .show li {
  display: block;
  white-space: nowrap;
}

.codelos-signout-dropdown ul .signout-text {
  border-top: 1px solid #eee;
  padding-top: 17px;
  user-select: none;
}
.codelos-signout-dropdown ul .signout-text.signout-btn p {
  font-size: 12px !important;
  color: #abaeb6;
  text-transform: uppercase;
  cursor: pointer;
}
.codelos-signout-dropdown ul .signout-text p {
  padding: 0;
  font-size: 16px;
  user-select: none;
  color: #abaeb6;
  font-weight: 400;
}

.codelos-signout-dropdown ul .signout-text ::v-deep .Button__button___1FrBC {
  text-align: left !important;
  color: #abaeb6 !important;
}

.codelos-signout-dropdown ul .signout-text {
  user-select: none;
}

/* New topbar */
.codelos-top-bar {
  padding: 0px 36px 15px 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  height: 130px;
  box-sizing: border-box;
}

.codelos-top-bar .codelos-left-top-menu .codelos-left-menu-list {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  column-gap: 50px;
}

.codelos-top-bar
  .codelos-left-top-menu
  .codelos-left-menu-list
  .codelos-left-menu-list-item {
  font-size: 15px;
  font-weight: 500;
  color: #a3a3a3;
  cursor: pointer;
  display: flex;
  align-items: end;
}

.codelos-top-bar .codelos-left-menu-list-item span {
  line-height: 1;
}

.codelos-top-bar
  .codelos-left-top-menu
  .codelos-left-menu-list
  .codelos-left-menu-list-item.active {
  color: #333343;
}

.codelos-top-bar
  .codelos-left-top-menu
  .codelos-left-menu-list
  .codelos-left-menu-list-item
  img {
  max-width: 100%;
  height: 18px;
}

.codelos-top-bar
  .codelos-left-top-menu
  .codelos-left-menu-list
  .codelos-left-menu-list-item
  span {
  margin-left: 10px;
}
.codelos-top-bar
  .codelos-left-top-menu
  .codelos-left-menu-list
  .codelos-left-menu-list-item
  span {
  margin-left: 10px;
}

.codelos-top-bar .codelos-left-top-menu .codelos-left-menu-list svg {
  width: 15px;
  height: 15px;
  position: relative;
  top: -2px;
}

.codelos-left-right-menu .codelos-left-right-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.codelos-left-right-menu .codelos-left-right-list ::v-deep .dropdown button {
  background: transparent;
  border: none;
  color: #333343;
  padding: 0;
  box-shadow: none;
}
.codelos-top-bar .codelos-left-top-menu {
  height: 54px;
  display: flex;
  align-items: center;
}
.codelos-top-bar .custom-checklist-menu {
  display: flex;
  align-items: center;
}
.codelos-top-bar .custom-checklist-menu input {
  width: 15px;
  margin-left: 5px;
}
.codelos-top-bar .codelos-left-menu-list-text {
  font-family: 'AktivGroteskMedium';
}
.codelos-top-bar ::v-deep .signout-text .b-dropdown-text div {
  margin-bottom: 0;
}
.codelos-top-bar .agb-container span {
  display: flex;
  align-items: center;
}

.codelos-top-bar ::v-deep .agb-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
}

.codelos-top-bar ::v-deep .agb-container .vertical-line {
  border-left: 2px solid #abaeb6;
  height: 14px;
  margin: 0 8px;
}
.codelos-top-bar ::v-deep .agb-container a {
  color: #abaeb6;
  text-decoration: none;
  line-height: 10px;
}
</style>
